import { GET } from '../request'

export const getAnalisisEncuesta = version =>
  GET('/api/core/marketing/respuesta-encuesta/analisis', { version })
